<template>
    <!-- 批量添加设备 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="getDataList"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item  prop="product_key">
            <template slot="label">
              <span class="required">*</span>
              <span>产品</span>
            </template>
            <v-select id="product_key"  name="product_key" v-model="ruleForm.product_key" :options="productOptins"></v-select>
          </v-form-item>

            <v-form-item class="listfile" prop="listFile">
              <template slot="label">
              <span class="required">*</span>
              <span>上传文件</span>
            </template>
                <v-upload
                action="/td/td-iot-api/iot/dev/upload/v1"
                ref="upload"
                name="dev_file"
                accept=".xlsx"
                :WfileName="WfileName"
                updataType="excell"
                :on-change="hidemsg"
                :noName="noName"
                show-file-list
                @showtips="showfiletips"
                ></v-upload>
                <span><v-button class="ml10" size="M" type="text" name="btn2" slot="reference" @click="downFile">下载模板</v-button> </span>
                <div class="filetip" ref="filetip">未选择文件</div>
              </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>

    </div>

</template>

  <script>
// import { copy } from '@/common/libs/utils';

  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
  },
    data() {
      return {
        rules: {
        },
        ruleForm:{
          product_key:'',
        },
        dialogTitle: "批量添加设备",
        WfileName:'',
        productOptins:[],
        isShow:false,
        enable:'on',
        noName:false,
        upTips:true,
        file:''
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      showfiletips(){
        this.$refs.filetip.style.display = "block";
      },
      hidemsg(e,file){
        if(file.indexOf('.xlsx')==-1){
          this.$message.error("只支持xlsx格式的文件")
          this.noName = true
          return false
        }
        this.noName = false
        this.upTips = false
        this.$refs.filetip.style.display = "none";
        this.file = e.target.files[0]
        this.WfileName = file
        this.upTips = true
      },
      async downFile(){
        this.$getData("/td/td-iot-api/iot/dev/download/v1",).then((res)=>{
          if(res.code == 0){
            window.open(res.data.document_url)
          }
        })
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        if(this.file == ''){
          this.$refs.filetip.style.display = "block";
          this.$message.error("请检查错误信息")
          return
        }
        var subdata = new FormData()
        subdata.append('app_id', sessionStorage.getItem("appid") || "")
        subdata.append('product_key', this.ruleForm.product_key)
        subdata.append('dev_file', this.file)
        this.$post("/td/td-iot-api/iot/dev/upload/v1", subdata, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
            this.$emit('update:showInputDialog',false)
            this.ruleForm.product_key = ''
            this.WfileName = ''
            this.file = ''
          } else {
            this.$refs.upload.clearFile()
            this.WfileName = ''
            this.file = ''
            this.noName = true
            this.$message.error(res.msg);
            return
          }
        });

      },
      async getDataList(){
        const subData = {
          page_num: 1,
          page_size: 10000,
          app_id: sessionStorage.getItem("appid") || "",
        };
        const res = await this.$post(
          "/td/td-iot-api/iot/product/page/v1",
          subData,
          false
        );
        if(res.code === 0){
          this.productOptins = res.data.list.map((item) =>{
            return {
              label: item.product_name,
              value: item.product_key,
            }
          })
        }else{
          if(res.code == '100410'){
            setTimeout(() => {
              this.getData()
            },1000)
          }else{
            this.$message.error(res.msg);
          }
        }
      },
      handleAfterClose() {
        // this.ruleForm.product_key = ''
        // this.WfileName = ''
        // this.file = ''
        Object.assign(this.$data, this.$options.data())
        this.$emit('update:showInputDialog',false)
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">

  </style>
